import { FooterLayout, ReleasePage } from "@reactjscomponentrepository/frontend-components/lib/components";
import LogoSim from "./../images/logotipo_sim_interior.svg";


export const Release = () => {

  const breadcrumbs = [
    { path: '/', breadcrumb: 'Inicio' },
    { path: '/release', breadcrumb: 'Versiones' }
  ];

  const releases = [
    {
      title: 'Versión 1.0.0',
      date: new Date("2023,01,13"),
      subtitle: 'Primer versión del sistema integrador de metadatos',
      features: ['APM (0.10.41) - Gestión de Conceptos, Catálogos y Plantillas',
                'CAM (0.13.42) - ',
                'CVM (0.10.41) - ',
                'ADMIN (0.5.12) - '
              ]
    }
  ]

  return (
    <>
      <ReleasePage title="Versiones" subtitle="SIM" releases={releases} systemLogo={LogoSim} 
      customBreadcrumbs={breadcrumbs} showRootBreadcrumb={true} footer={<FooterLayout />}/>
    </>
  );
}